// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ITokenRequestDto
 */
export interface ITokenRequestDto {
    /**
     * 
     * @type {string}
     * @memberof ITokenRequestDto
     */
    user_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ITokenRequestDto
     */
    refresh_token?: string;
    /**
     * 
     * @type {string}
     * @memberof ITokenRequestDto
     */
    aud?: string;
}

/**
 * Check if a given object implements the ITokenRequestDto interface.
 */
export function instanceOfITokenRequestDto(value: object): value is ITokenRequestDto {
    return true;
}

export function ITokenRequestDtoFromJSON(json: any): ITokenRequestDto {
    return ITokenRequestDtoFromJSONTyped(json, false);
}

export function ITokenRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ITokenRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'user_name': json['user_name'] == null ? undefined : json['user_name'],
        'refresh_token': json['refresh_token'] == null ? undefined : json['refresh_token'],
        'aud': json['aud'] == null ? undefined : json['aud'],
    };
}

export function ITokenRequestDtoToJSON(json: any): ITokenRequestDto {
    return ITokenRequestDtoToJSONTyped(json, false);
}

export function ITokenRequestDtoToJSONTyped(value?: ITokenRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'user_name': value['user_name'],
        'refresh_token': value['refresh_token'],
        'aud': value['aud'],
    };
}

